export const Language = Object.freeze({
  ENGLISH: 1,
  DUTCH: 2
})
